<template>
  <div>
    <div class="spaceBetween search-box">
      <span class="search-title">Producer Authentication List</span>
      <div class="spaceLeft search-form">
        <div class="search-item">
          <el-input
            class="search-input"
            v-model="searchData.recipientName"
            placeholder="Business Name"
            @keyup.enter="getList"
          >
            <el-button slot="append" size="mini" @click="getList">
              <svg-icon icon-class="tn-search" />
            </el-button>
          </el-input>
        </div>
        <div class="search-item">
          <el-input
            class="search-input"
            v-model="searchData.tnEthAccount"
            placeholder="treasurenet Account"
            @keyup.enter="getList"
          >
            <el-button slot="append" size="mini" @click="getList">
              <svg-icon icon-class="tn-search" />
            </el-button>
          </el-input>
        </div>
      </div>
    </div>

    <div class="pad">
      <el-table stripe :data="tableList" v-loading="loading" highlight-current-row>
        <el-table-column prop="registrationDate" label="Date" show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{ moment(row.registrationDate).format("YYYY-MM-DD HH:mm") }}
          </template>
        </el-table-column>
        <el-table-column prop="recipientName" label="Business Name" />
        <el-table-column prop="tnEthAccount" label="treasurenet Account">
          <template slot-scope="{ row }">
            <account :value="row.tnEthAccount" />
          </template>
        </el-table-column>
        <el-table-column prop="Operation" label="Operation" width="150px">
          <template slot-scope="{ row }">
            <span class="text-link" @click="handleApprove(row)">Approval</span>
            <!-- <span class="text-link" v-else-if="row.status != 0" @click="toDetail(row)"
              >Details</span
            > -->
          </template>
        </el-table-column>
      </el-table>
      <div class="table-bottom-btn">
        <pagination
          :total="queryParams.total"
          :page.sync="queryParams.page"
          :limit.sync="queryParams.eachpage"
          @pagination="getList()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { producerList, producerUpdateStatus } from "@/api/manager.js";
import authStatus from "./authStatus.vue";
export default {
  components: { authStatus },
  data() {
    return {
      loading: false,
      searchData: {
        recipientName: undefined,
        tnEthAccount: undefined,
      },
      tableList: [],
      queryParams: {
        total: 0,
        page: 1,
        pageSize: 10,
      },
    };
  },
  computed: {},
  methods: {
    valChange(data, key) {
      this.searchData[key] = data.value;
      this.getList();
    },
    getList() {
      const param = {
        page: this.queryParams.page,
        pageSize: this.queryParams.pageSize,
        ...this.searchData,
      };
      this.loading = true;
      producerList(param)
        .then((res) => {
          this.tableList = res.result.list;
          this.queryParams.total = res.result.total;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    handleApprove(row) {
      this.$confirm(
        "Are you sure to approve the application ?",
        "Operation confirmation",
        {
          customClass: "page-btns",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
        }
      ).then(() => {
        const param = {
          status: 2,
          userID: row.userID,
          refusalReason:'',
        };
        producerUpdateStatus(param).then((res) => {
          this.$message.success("Approved successfully!");
          this.getList();
        });
      });
    },
  },
  created() {
    this.getList();
  },
};
</script>
<style scoped lang="scss">
.pad {
  padding: 0.04rem 0.32rem;
}
.search-box {
  padding: 0.24rem 0.32rem;
  border-bottom: 1px solid #f0f0f0;

  .search-title {
    font-size: 0.22rem;
    font-weight: bold;
  }
  .search-item {
    margin-left: 0.24rem;
  }
}
</style>
